import { getPaginatedCodelistUrl, getDataFromDatasetUrl, getDataFromCodeListUrl, submitTranscoding01Url, getTranscodingCodeMatch, getTranscodingUrl, submitTranscodingTimeDimensionUrl, deleteMappingUrl, getTranscodignUrl, saveDimensionTranscodingUrl, deleteDimensionTranscodingUrl } from "../../../../constants/urls";
import { deleteRequest, getRequest, postRequest } from "../../../../middlewares/api/actions";
import { generateDataToSaveTranscoding } from "./settings/utils";

export const TRANSCODING_SETTINGS_HIDE = 'TRANSCODING_SETTINGS_HIDE';
export const TRANSCODING_SETTINGS_MODE = 'TRANSCODING_SETTINGS_MODE';
export const TRANSCODING_SETTINGS_DATASET_COLUMN = 'TRANSCODING_SETTINGS_DATASET_COLUMN';
export const TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET = 'TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET';
export const TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST = 'TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST';
export const TRANSCODING_SETTINGS_HIDE_TIME_DIMENSION = 'TRANSCODING_SETTINGS_HIDE_TIME_DIMENSION';
export const TRANSCODING_SIMPLE_VALUE_SET = 'TRANSCODING_SIMPLE_VALUE_SET';
export const TRANSCODING_SIMPLE_VALUE_SUBMIT = 'TRANSCODING_SIMPLE_VALUE_SUBMIT';
export const TRANSCODING_SETTINGS_UPDATE_CODELIST = 'TRANSCODING_SETTINGS_UPDATE_CODELIST';
export const TRANSCODING_SETTINGS_DATA_TABLE = 'TRANSCODING_SETTINGS_DATA_TABLE';
export const TRANSCODING_SETTINGS_DATA_CODE_MATCH = 'TRANSCODING_SETTINGS_DATA_CODE_MATCH';
export const TRANSCODING_SETTINGS_DATA_CLEAR_CHANGES = 'TRANSCODING_SETTINGS_DATA_CLEAR_CHANGES';
export const TRANSCODING_SETTINGS_DATA_IMPORT_DATA_FILE = 'TRANSCODING_SETTINGS_DATA_IMPORT_DATA_FILE';
export const TRANSCODING_SETTINGS_DATA_TABLE_DELETE_DSD_VALUE_ITEM = 'TRANSCODING_SETTINGS_DATA_TABLE_DELETE_DSD_VALUE_ITEM';
export const TRANSCODING_GET_ID = 'TRANSCODING_GET_ID';
export const TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_SHOW = 'TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_SHOW'
export const TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_HIDE = 'TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_HIDE'
export const TRANSCODING_SETTINGS_HIDE_DIMENSION = 'TRANSCODING_SETTINGS_HIDE_DIMENSION'
export const TRANSCODING_DELETE_MAPPING = 'TRANSCODING_DELETE_MAPPING';
export const TRANSCODING_CHANGE_LANGUAGE = 'TRANSCODING_CHANGE_LANGUAGE';
export const TRANSCODING_SETTINGS_SAVE_DIMENSION = 'TRANSCODING_SETTINGS_SAVE_DIMENSION';
export const TRANSCODING_SETTINGS_DELETE_DIMENSION = 'TRANSCODING_SETTINGS_DELETE_DIMENSION';
export const TIME_TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET = 'TIME_TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET';
export const TRANSCODING_LIST_CODELIST_CODES_ITEMS_PAGE_READ = 'TRANSCODING_LIST_CODELIST_CODES_ITEMS_PAGE_READ';

export const submitSimpleValueTranscoding = (value, mappingId) => ({
    ...postRequest(
        TRANSCODING_SIMPLE_VALUE_SUBMIT,
        submitTranscoding01Url(),
        {
            ConstantValue: value,
            IdMappingToDelete: mappingId
        },
        t => ({
            success: t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding')
        })
    ),
    value,
    mappingId
})

export const setTranscodingSimpleValueSettings = (value) => ({
    type: TRANSCODING_SIMPLE_VALUE_SET,
    value
});

export const hideTranscodingSettings = () => ({
    type: TRANSCODING_SETTINGS_HIDE
})

export const setTranscodingMode = (mode) => ({
    type: TRANSCODING_SETTINGS_MODE,
    mode
})

export const hideTranscodingSettingsTimeDimension = () => ({
    type: TRANSCODING_SETTINGS_HIDE_TIME_DIMENSION
})

export const hideTranscodingSettingsWithoutTimeDimension = () => ({
    type: TRANSCODING_SETTINGS_HIDE_DIMENSION
})

export const setTranscoding = (data, isTimeTranscoding) => ({
    ...getRequest(
        TRANSCODING_SETTINGS_DATASET_COLUMN,
        getTranscodingUrl(data.entityId, isTimeTranscoding)),
    data
});

export const getDataFromDataset = (entityId, columns) => postRequest(
    TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET,
    getDataFromDatasetUrl(entityId),
    columns
)

export const getDataFromCodelist = (codelistTriplet) => getRequest(
    TRANSCODING_SETTINGS_GET_DATA_FROM_CODELIST,
    getDataFromCodeListUrl(codelistTriplet.agencyID, codelistTriplet.id, codelistTriplet.version)
)

export const updateCodelist = (codelist) => ({
    type: TRANSCODING_SETTINGS_UPDATE_CODELIST,
    codelist
})

export const dataTable = (data) => ({
    type: TRANSCODING_SETTINGS_DATA_TABLE,
    data
})

export const getCodeMatch = (dataTable,triplet, columnName) => postRequest(
    TRANSCODING_SETTINGS_DATA_CODE_MATCH,
    getTranscodingCodeMatch(triplet.agencyID, triplet.id, triplet.version, columnName),
    dataTable
)

export const clearTranscodingUI = () => ({
    type: TRANSCODING_SETTINGS_DATA_CLEAR_CHANGES
})

export const importTranscodingFromCsvFile = (csvData, t) => ({
    type: TRANSCODING_SETTINGS_DATA_IMPORT_DATA_FILE,
    csvData,
    t
})

export const deleteDSDValueComponentToTable = (index) => ({
    type: TRANSCODING_SETTINGS_DATA_TABLE_DELETE_DSD_VALUE_ITEM,
    index
})

export const getTranscoding = mappingComponentId => getRequest(
    TRANSCODING_GET_ID,
    getTranscodignUrl(mappingComponentId)
)

export const showDsdComponentModal = index => ({
    type: TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_SHOW,
    index
})

export const hideDsdComponentModal = () => ({
    type: TRANSCODING_SETTINGS_DATA_TABLE_COMPONENT_DSD_MODAL_HIDE,
})

export const saveTimeDimensionTranscoding = (data, timeTranscodings, idTimeDimensionMapping) => {
    return ({
        ...postRequest(
            TRANSCODING_SETTINGS_SAVE_DIMENSION,
            submitTranscodingTimeDimensionUrl(),
            {
                TranscodingEntityId: idTimeDimensionMapping ? idTimeDimensionMapping : null,
                ComponentMappingEntityId: data.entityId, // ID DEL MAPPING
                TimeTranscodings: timeTranscodings,

            },
            t => ({
                success: t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.successMessage')
            })
        ),
        entityId: data.entityId,
        dsdType: data.dsdType
    })
}

export const saveDimensionTranscoding = (data, dataTable) => ({
    ...postRequest(
        TRANSCODING_SETTINGS_SAVE_DIMENSION,
        saveDimensionTranscodingUrl(),
        generateDataToSaveTranscoding(data, dataTable),
        t => ({
            success: t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.successMessage')
        })
    ),
    entityId: data.entityId,
    dsdType: data.dsdType
})

export const deleteDimensionTranscoding = (data, isTimeTranscoding) => ({
    ...deleteRequest(
    TRANSCODING_SETTINGS_DELETE_DIMENSION,
    deleteDimensionTranscodingUrl(data.entityId, isTimeTranscoding),
    t => ({
        success: t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.deleteMessage')
    })),
    entityId: data.entityId,
    dsdType: data.dsdType
})

export const deleteMapping = (mappingId, isTimeMapping) => ({
    ...deleteRequest(
        TRANSCODING_DELETE_MAPPING,
        deleteMappingUrl(mappingId, isTimeMapping),
        t => ({
            success: t('scenes.mappingHandler.MappingSet.wizard.steps.second.transcoding.deleteMessage')
        })
    )
})

export const changeLanguage = (language) => ({
    type: TRANSCODING_CHANGE_LANGUAGE,
    language
})

export const getDataFromDatasetColumn = (datasetId, columnName) => ({
    ...postRequest(
        TIME_TRANSCODING_SETTINGS_GET_DATA_FROM_DATASET,
        getDataFromDatasetUrl(datasetId),
        columnName
    ),
    columnName
})

export const readComponentCodelistCodesItemsPage = (pageNum, pageSize, searchText, filters, sortCol, sortByDesc, codelist, language) => ({
  ...postRequest(
    TRANSCODING_LIST_CODELIST_CODES_ITEMS_PAGE_READ,
    getPaginatedCodelistUrl(),
    ({
      Id: codelist.id,
      AgencyId: codelist.agencyID,
      Version: codelist.version,
      Lang: language,
      PageNum: pageNum,
      PageSize: pageSize,
      AllSearch: searchText,
      CodeSearch: filters.id ? filters.id : undefined,
      NameSearch: filters.name ? filters.name : undefined,
      ParentSearch: filters.parent ? filters.parent : undefined,
      SortColumn: sortCol ? sortCol : undefined,
      SortDesc: sortByDesc ? sortByDesc : undefined,
      rebuildDb: false
    })
  )
});